import styled from 'styled-components';


const Pictogram = styled.div<{ $height: string, $width: string, $backgroundImage: string }>`
  background-image: ${({ $backgroundImage }) => `url(${$backgroundImage})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: ${({ $height }) => ($height ?? '80px')};
  width: ${({ $width }) => ($width ?? '80px')};
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
`;

export default Pictogram;
